import styled, { css } from "styled-components";
import * as helpers from "../../_themes/helpers";
import { hoverSupported } from "../../_utils/styleUtils";
import { BaseButton } from "../../BaseButton";

export const Wrapper = styled(BaseButton)`
  border: 0.1em solid
    ${helpers.getColor("settingButtonBorder", "settingButton.border")};
  border-radius: 999px;
  text-align: center;
  vertical-align: middle;
  cursor: ${({ active }) => (active ? "auto" : "pointer")};

  background: ${({ active, theme }) =>
    active
      ? helpers.getSelectedColor(
          "settingButtonBackground",
          "settingButton.background"
        )({ theme })
      : helpers.getColor(
          "settingButtonBackground",
          "settingButton.background"
        )({ theme })};

  color: ${({ active, theme }) =>
    active
      ? helpers.getSelectedColor("settingButton")({ theme })
      : helpers.getColor("settingButton")({ theme })};

  ${({ active }) =>
    active
      ? ""
      : hoverSupported(css`
          &:hover {
            background: ${helpers.getHoverColor(
              "settingButtonBackground",
              "settingButton.background"
            )};
            border-color: ${helpers.getHoverColor(
              "settingButtonBorder",
              "settingButton.border"
            )};
            color: ${helpers.getHoverColor("settingButton")};
          }
        `)};

  &[disabled] {
    background: ${helpers.getDisabledColor(
      "settingButtonBackground",
      "settingButton.background"
    )};
    border-color: ${helpers.getDisabledColor(
      "settingButtonBorder",
      "settingButton.border"
    )};
    color: ${helpers.getDisabledColor("settingButton")};
    cursor: default;
  }
`;
